"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IndexedAnimationObject_1 = require("../IndexedAnimationObject");
var AbstractAnimationValue_1 = require("../properties/AbstractAnimationValue");
var EffectValueType;
(function (EffectValueType) {
    EffectValueType[EffectValueType["Slider"] = 0] = "Slider";
    EffectValueType[EffectValueType["Angle"] = 1] = "Angle";
    EffectValueType[EffectValueType["Color"] = 2] = "Color";
    EffectValueType[EffectValueType["Point"] = 3] = "Point";
    EffectValueType[EffectValueType["CheckBox"] = 4] = "CheckBox";
    EffectValueType[EffectValueType["DropDown"] = 7] = "DropDown";
    EffectValueType[EffectValueType["Layer"] = 10] = "Layer";
})(EffectValueType = exports.EffectValueType || (exports.EffectValueType = {}));
var EffectValue = (function (_super) {
    tslib_1.__extends(EffectValue, _super);
    function EffectValue(type, rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.type = type;
        _this.value = new AbstractAnimationValue_1.AbstractAnimationValue(rawData.v, version);
        return _this;
    }
    Object.defineProperty(EffectValue.prototype, "matchName", {
        get: function () {
            return this._rawData.mn;
        },
        set: function (name) {
            this._rawData.mn = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectValue.prototype, "name", {
        get: function () {
            return this._rawData.nm;
        },
        set: function (name) {
            this._rawData.nm = name;
        },
        enumerable: true,
        configurable: true
    });
    EffectValue.prototype.toJSON = function () {
        return {
            type: this.type,
            index: this.index,
        };
    };
    return EffectValue;
}(IndexedAnimationObject_1.IndexedAnimationObject));
exports.EffectValue = EffectValue;
//# sourceMappingURL=EffectValue.js.map